import NoImageSrc from "@/assets/images/no_image.svg";
import { BannerType } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { getFieldValue, getLangFromLocale } from "@/utils/common";
// import Image from "next/image";
import { CLink } from "../common/customLink/CustomLink";
import CldImage from "../ui/cldImg/CldImage";

interface IProps {
  content: BannerType;
  locale: string;
}

const PlpImageBannerView = ({ content, locale }: IProps) => {
  const lang = getLangFromLocale(locale);

  return (
    <CLink href={content?.link?.url}>
      {/* mobile view */}
      <div
        className={cn(
          "md:hidden",
          // content.bannerType === "small"
          //   ? "aspect-square md:aspect-[5.01/1]"
          //   : "aspect-[0.63/1] md:aspect-[2.2/1]",
        )}
      >
        <CldImage
          src={
            content?.media?.smallMediaUrl[lang]
              ? getCloudinaryURL(content?.media?.smallMediaUrl[lang])
              : NoImageSrc
          }
          alt={getFieldValue(lang, "Promotional Banner", "لافتة ترويجية") ?? "Promotional Banner"}
          height={content.bannerType === "small" ? 375 : 597}
          width={375}
          className={cn(`w-full object-cover`, content.bannerType === "small" ? "aspect-square" : "aspect-[0.63/1]")}

        />
      </div>

      {/* desktop view */}
      <div
        className={cn(
          "hidden md:block",
          // content.bannerType === "small"
          //   ? "aspect-square md:aspect-[5.01/1]"
          //   : "aspect-[0.63/1] md:aspect-[2.2/1]",
        )}
      >
        <CldImage
          src={
            content?.media?.largeMediaUrl[lang]
              ? getCloudinaryURL(content?.media?.largeMediaUrl[lang])
              : NoImageSrc
          }
          alt={getFieldValue(lang, "Promotional Banner", "لافتة ترويجية") ?? "Promotional Banner"}
          width={1400}
          height={content?.bannerType === "small" ? 290 : 654}
          className={cn(
            "w-full object-cover",
            content?.bannerType === "small" ? "aspect-[5.01/1]" : "aspect-[2.2/1]",
          )}


        />
      </div>
    </CLink>
  );
};

export default PlpImageBannerView;
